//component for mill bar feeder

import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuiItemComponent } from '@ral/ui:aui/item';
import { StoryCardComponent } from '@storyteller/card';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryTitleComponent } from '@storyteller/title';
import { hostBinding } from 'ngxtension/host-binding';
import { ROUTES_NAMES } from '../utils/routes';

@Component({
    selector: 'app-antbot-pro-cnc',
    imports: [
        StoryCardComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        AuiItemComponent,
        StoryImageComponent,
        RouterLink,
        StoryImageSourceComponent,
    ],
    template: ` <story-card>
        <story-image [fetchPriority]="'low'" class="@lg:aspect-[481/321] block aspect-[360/240]" alt="Antbot pro CNC">
            <story-source [src]="'assets/images/antbot-pro-cnc.jpg'" [width]="360" [height]="240" />
            <story-source
                [src]="'assets/images/antbot-pro-cnc.jpg'"
                [width]="579"
                [height]="386"
                media="(min-width: 32rem)"
            />
        </story-image>

        <story-title [headingLevel]="3" className="@lg:story-font-headline2 story-font-headline3"
            >Antbot pro CNC</story-title
        >
        <story-description [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-16 leading-[1.5]'">
            Moderní řešení pro snadnou robotizaci a&nbsp;efektivní CNC výrobu.
        </story-description>

        <a
            auiItem
            [size]="'40'"
            [color]="'primary'"
            [fullWidth]="true"
            [attr.data-testid]="'story-button'"
            class="@lg:max-w-[268px] flex-none"
            [routerLink]="['/', routeName]"
            [ariaLabel]="'Prohlédnout produkt na stránce Antbot pro CNC'"
        >
            <span auiItemLabel>Prohlédnout produkt</span>
        </a>
    </story-card>`,
})
export class AntBotCncComponent {
    routeName = ROUTES_NAMES.antBotProCnc;
    hostClass = hostBinding(
        'class',
        computed(() => 'block h-full w-full')
    );
}
